
import useAccount from "@/composables/useAccount";
import useAccountPages from "@/composables/useAccountPages";
import usePassengerDetailPages from "@/composables/usePassengerDetailPages";
import { Component, UserType } from "@/models/enums";
import { useUserStore } from "@/store/user";
import useVuelidate from "@vuelidate/core";
import {
	email,
	helpers,
	maxLength,
	minLength,
	required,
} from "@vuelidate/validators";
import { defineComponent, reactive, ref } from "vue";
import BaseButton from "@/components/base/BaseButton.vue";
import BaseDateInput from "@/components/base/BaseDateInput.vue";
import BaseInput from "@/components/base/BaseInput.vue";

export default defineComponent({
	components: {
		BaseInput,
		BaseDateInput,
		BaseButton,
	},
	setup() {
		const { create } = useAccount();
		const accountPages = useAccountPages();
		const passengerDetailPages = usePassengerDetailPages();
		const userStore = useUserStore();
		const loading = ref<boolean>(false);

		const state = reactive({
			email: userStore.getUser.email,
			firstName: "",
			lastName: "",
			dateOfBirth: "",
			password: "",
			repeatPassword: "",
		});

		const rules = {
			email: { required, email },
			firstName: { required },
			lastName: { required },
			dateOfBirth: { required },
			password: {
				required,
				min: helpers.withMessage(() => "Minimum 6 characters", minLength(6)),
				max: helpers.withMessage(() => "Maximum 10 characters", maxLength(10)),
			},
			repeatPassword: {
				v: helpers.withMessage(
					() => "Passwords do not match",
					(value: string) => value === state.password
				),
			},
		};

		const v$ = useVuelidate(rules, state);

		const goToLogin = () => {
			accountPages.setComponent(Component[Component.AccountLogin]);
		};

		const submit = async () => {
			v$.value.$touch();
			const isValid = await v$.value.$validate();

			if (isValid) {
				loading.value = true;
				create(state)
					.then((result) => {
						if (result) {
							userStore.setUser({ ...result, type: UserType.Customer });
							passengerDetailPages.setComponent(
								Component[Component.PassengerDetails]
							);
						}
					})
					.finally(() => (loading.value = false));
			}
		};

		return { goToLogin, v$, submit, loading };
	},
});
